import React from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { useUserContext } from "../../context/UserProvider";
import { ArrowBackIcon } from "../util/Icons";
import SubMenuWrapper, { SubMenuItem } from "../util/SubMenu";
import PlushieGeneratorPage from "./ImageGenerator";
import PhotoBoothPage from "./PhotoBooth";
import MemoryGamePage from "./MemoryGame";
import FallBingoPage from "./FallBingo";
import PlaygroundHub from "./PlaygroundHub";

export default function ImageGeneratorMain() {
  const { user, canSocialFeed, userLoading } = useUserContext();

  if (userLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/createaccount" replace={true} />;
  }

  if (!canSocialFeed) {
    return (
      <div className="-mx-3 min-h-screen bg-white">
        <SubMenuWrapper bar>
          <SubMenuItem icon={<ArrowBackIcon size={24} color="#6b7280" />} label="Home" to="/" />
        </SubMenuWrapper>

        <div className="mx-auto max-w-4xl px-3 py-3 md:px-4 md:py-5">
          <div className="text-center mt-8">
            <div
              className="rounded-3xl p-8"
              style={{
                background: "linear-gradient(135deg, #f1f5f9 0%, #e0e7ff 100%)",
                border: "1px solid rgba(99, 102, 241, 0.15)",
              }}
            >
              <span className="text-6xl mb-4 block">🔒</span>
              <h2 className="text-2xl font-bold mb-4" style={{ color: "#1e293b" }}>
                Active Registration Required
              </h2>
              <p className="text-base mb-6" style={{ color: "#64748b" }}>
                Image Generator tools are available to users with an active race registration or Momentum Membership.
              </p>
              <Link
                to="/membership"
                className="inline-block rounded-2xl px-8 py-4 font-bold text-lg transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl no-underline"
                style={{
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  color: "white",
                  boxShadow: "0 10px 40px rgba(99, 102, 241, 0.3)",
                }}
              >
                Become a Member
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<PlaygroundHub />} />
      <Route path="/plushie-avatar" element={<PlushieGeneratorPage />} />
      <Route path="/photo-booth" element={<PhotoBoothPage />} />
      <Route path="/memory-game" element={<MemoryGamePage />} />
      <Route path="/fall-bingo" element={<FallBingoPage />} />
      <Route path="/*" element={<Navigate to={"./"} replace={true} />} />
    </Routes>
  );
}
